import AsyncStorage from '@react-native-async-storage/async-storage';
import { getApiUrl } from '../../config/development';

export const getFeedbackList = async (params = {}) => {
    try {
        const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
        const queryString = new URLSearchParams(params).toString();
        const url = `${getApiUrl()}/feedback/admin?${queryString}`;

        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
            }
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching feedback:', error);
        throw error;
    }
};

export const getFeedbackStats = async () => {
    try {
        const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
        const url = `${getApiUrl()}/feedback/admin/stats`;

        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
            }
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching feedback stats:', error);
        throw error;
    }
};

export const updateFeedback = async (id, updateData) => {
    try {
        const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
        const url = `${getApiUrl()}/feedback/admin/${id}`;

        const response = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateData)
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating feedback:', error);
        throw error;
    }
};
